import {useEffect} from 'react';

import Notification from '@/components/Notification';
import {getMorphoService, serviceNames} from '@/rte/editor';
import {feLogger, showSplitCardRecommendTip, closeSplitCardRecommendTip} from '@/buried';
import {pullCardStorageObj} from '@/utils/document/common';

import styles from './index.module.scss';
import toast, {ToastType} from '@/components/Toast';

interface IProps {
    setIsPullCardVis: (val: boolean) => void;
}

function PullCardTip(props: IProps) {
    const {setIsPullCardVis} = props;

    useEffect(() => {
        feLogger(showSplitCardRecommendTip());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        pullCardStorageObj.set();
        setIsPullCardVis(false);
        feLogger(closeSplitCardRecommendTip());
    };

    // 处理一键拆卡
    const handlePullCard = () => {
        const testConfig = getMorphoService(serviceNames.ICardService);
        if (testConfig && testConfig.reSlide) {
            testConfig.reSlide({
                // 本次拆卡需求，ignoreAvoidCardBreak需要给 true
                ignoreAvoidCardBreak: true,
                source: 'hint',
            });
            toast({
                duration: 3000,
                type: ToastType.Success,
                content: '拆卡成功，可滚动页面查看效果',
            });
        }
        setIsPullCardVis(false);
    };

    return (
        <div className={styles.notification}>
            <Notification
                type={'info'}
                content={<span>
                    多人查看该文档，为让内容更清晰可读，试试
                    <a onClick={handlePullCard}>
                        一键拆卡
                    </a>
                </span>}
                onClose={handleClose}
            />
        </div>
    );
}

export default PullCardTip;
